import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  Input,
} from '@angular/core';
import {
  ProductCardConfiguration,
  ProductCardConfigurationKeys,
  PRODUCT_CARD_FEATURE_NAME,
} from '@epicuro-next/constants/rule-engine/product-card-rules';
import {
  ConfigurationsService,
  selectConfigurationValueFrom,
} from '@epicuro-next/platform/configuration';
import { selectLanguage } from '@epicuro-next/platform/i18n';
import { selectShowEstimatedDeliveryDate } from '@epicuro-next/state/p-basket-state';
import { select, Store } from '@ngrx/store';
import { Product } from 'graphql-api/gql-api-interfaces';

@Component({
  selector: 'epc-product-card-icons',
  styleUrls: ['./product-card-icons.component.scss'],
  templateUrl: './product-card-icons.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ProductCardIconsComponent {
  @Input() public product: Product;
  @Input() public showPopularityIcon = true;
  public showNewIcon = input(true);
  // remove after all p-card moved to search v2
  public showGenderIcon = input(true);
  public showMraIcon = input(true);

  public readonly showGenderIconRule = this.store.selectSignal(
    selectConfigurationValueFrom<
      ProductCardConfigurationKeys.ProductShowGender,
      ProductCardConfiguration
    >(
      PRODUCT_CARD_FEATURE_NAME,
      ProductCardConfigurationKeys.ProductShowGender,
      false,
    ),
  );

  public readonly isGenderIconShown = computed(
    () => this.showGenderIcon() && !!this.showGenderIconRule(),
  );

  public readonly language$ = this.store.pipe(select(selectLanguage));

  public readonly dateFormat$ = this.configsService.getConfigValue<
    ProductCardConfiguration,
    ProductCardConfigurationKeys.DateFormat
  >({
    namespace: PRODUCT_CARD_FEATURE_NAME,
    featureName: ProductCardConfigurationKeys.DateFormat,
    defaultValue: 'MMM y',
  });

  public readonly showEstimatedDeliveryDate$ = this.store.pipe(
    select(selectShowEstimatedDeliveryDate),
  );

  constructor(
    private readonly configsService: ConfigurationsService,
    private readonly store: Store,
  ) {}
}
